import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { KnowledgeBaseItemInterface } from '@app/core/interfaces/knowledge-base-item.interface';
import { AppRoutesEnum } from '@app/routes';

@Component({
    selector: 'ins-knowledgebase-article-list',
    templateUrl: './knowledgebase-article-list.component.html',
})
export class KnowledgebaseArticleListComponent implements OnInit, OnChanges {
    @Input() knowledgeBaseItems: KnowledgeBaseItemInterface[] = [];
    @Input() columns: 2 | 3 | 4 = 2;

    public appRoutesEnum = AppRoutesEnum;

    public knowledgeBaseItemGroups: KnowledgeBaseItemInterface[][];

    public get columnClass(): string {
        return `col-${12 / this.columns}`;
    }

    ngOnInit(): void {
        this.setGroups();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.columns || changes.knowledgeBaseItems) {
            this.setGroups();
        }
    }

    private setGroups(): void {
        this.knowledgeBaseItemGroups = this.intoGroups(this.knowledgeBaseItems, this.columns);
    }

    private intoGroups(array: KnowledgeBaseItemInterface[], numberOfGroups: number): KnowledgeBaseItemInterface[][] {
        if (!array?.length) {
            return [];
        }
        const groupSize = Math.ceil(array.length / numberOfGroups);
        return Array.from(
            new Array(numberOfGroups),
            (_, index: number) => array.slice(index * groupSize, (index + 1) * groupSize),
        );
    }
}
